<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="toc" id="toc">
<h1 class="ctfm"><a class="page" id="pv"></a>Contents</h1>
<p class="tocfm"><a class="xref" href="#/Weiler0007#pref"><span class="page" data-locator="pv"></span>Preface</a></p>
<p class="toc"><a class="xref" href="#/Weiler0009#intro">Introduction</a></p>
<p class="toc"><a class="xref" href="#/Weiler0010#ch01">Chapter One</a></p>
<p class="toc1">A New England Girlhood</p>
<p class="toc"><span class="xref" href="#/Weiler0011#ch02" title="Link target outside of Sample">Chapter Two</span></p>
<p class="toc1">The Woman’s Era</p>
<p class="toc"><span class="xref" href="#/Weiler0012#ch03" title="Link target outside of Sample">Chapter Three</span></p>
<p class="toc1">Contending Forces</p>
<p class="toc"><span class="xref" href="#/Weiler0013#ch04" title="Link target outside of Sample">Chapter Four</span></p>
<p class="toc1">We Will Never Cease to Protest</p>
<p class="toc"><span class="xref" href="#/Weiler0014#ch05" title="Link target outside of Sample">Chapter Five</span></p>
<p class="toc1">Keen of Wit, a Brilliant Mind</p>
<p class="toc"><span class="xref" href="#/Weiler0015#aft" title="Link target outside of Sample">Afterword</span></p>
<p class="toc1">Maria Baldwin and Historical Memory</p>
<p class="tocbmf"><span class="xref" href="#/Weiler0016#notes" title="Link target outside of Sample">Notes</span></p>
<p class="tocbm"><span class="xref" href="#/Weiler0017#index" title="Link target outside of Sample">Index</span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Weiler0006.vue?3550f19e